import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { NotificationResponse } from '../../../../core/models/notification.model';
import { LayoutActions } from './layout.actions';

interface LayoutState {
  notifications: NotificationResponse[];
  unreadCount: number;
  notificationsLoading: boolean;
  notificationsError: string | null;
  profileImageUrl: string;
}

const initialState: LayoutState = {
  notifications: [],
  unreadCount: 0,
  notificationsLoading: false,
  notificationsError: null,
  profileImageUrl: '',
};

export const layoutFeature = createFeature({
  name: 'layout',
  reducer: createReducer(
    initialState,
    on(LayoutActions.loadNotifications, (state, { showLoading }) => ({
      ...state,
      notificationsLoading: showLoading ?? true,
      notificationsError: null,
    })),
    on(LayoutActions.loadNotificationsSuccess, (state, { notifications, unreadCount }) => ({
      ...state,
      notifications,
      unreadCount,
      notificationsLoading: false,
      notificationsError: null,
    })),
    on(LayoutActions.loadNotificationsFailure, (state, { error }) => ({
      ...state,
      unreadCount: 0,
      notificationsLoading: false,
      notificationsError: error,
    })),
    on(LayoutActions.loadProfileImageSuccess, (state, { profileImageUrl }) => ({
      ...state,
      profileImageUrl,
    })),
    on(LayoutActions.loadProfileImageFailure, (state) => ({
      ...state,
      profileImageUrl: '',
    })),
    on(LayoutActions.profileImageUpdated, (state, { profileImageUrl }) => ({
      ...state,
      profileImageUrl,
    })),
  ),
  extraSelectors: ({ selectUnreadCount }) => ({
    selectHasUnreadNotifications: createSelector(selectUnreadCount, (count) => count > 0),
  }),
});
